const platformAccess = {
  LATITUDE: 'latitude',
  LEGACY: 'legacy',
  ALL: 'all',
};

export default platformAccess;
